import React, { useContext, useState } from "react";
import { DialogContext } from ".";
import { DialogOptions } from "./DialogContext";

export enum DialogType {
  NONE = "none",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  INFO = "info",
}

export const useDialog = () => useContext(DialogContext);

const DialogProvider = ({ children }) => {
  const [status, setStatus] = useState(DialogType.NONE);
  const [dialogTitle, setDialogTitle] = useState<string>(null);
  const [dialogMessage, setDialogMessage] = useState<string>(null);
  const [dialogMessage2, setDialogMessage2] = useState<string>(null);
  const [dialogOptions, setDialogOptions] = useState<DialogOptions>(null);

  return (
    <DialogContext.Provider
      value={{
        status,
        dialogTitle,
        dialogMessage,
        dialogMessage2,
        options: dialogOptions,
        success: (message, title, options) => {
          setDialogTitle(title || "dialog.success.title.translation");
          setDialogMessage(
            message || "dialog.success.genericSuccess.translation",
          );
          setDialogOptions(options);
          setStatus(DialogType.SUCCESS);
        },
        warning: (message, title, _, options) => {
          setDialogTitle(title || "dialog.warning.title.translation");
          setDialogMessage(
            message || "dialog.warning.genericWarning.translation",
          );
          setDialogOptions(options);
          setStatus(DialogType.WARNING);
        },
        error: (message, message2, title, options) => {
          setDialogTitle(title || "dialog.error.title.translation");
          setDialogMessage(
            message || "dialog.warning.genericWarning.translation",
          );
          setDialogMessage2(message2 || "");
          setDialogOptions(options);
          setStatus(DialogType.ERROR);
        },
        clear: () => setStatus(DialogType.NONE),
      }}
    >
      {children}
    </DialogContext.Provider>
  );
};

export default DialogProvider;
